import { render } from "./FavoriteButton.vue?vue&type=template&id=3b690960&ts=true"
import script from "./FavoriteButton.vue?vue&type=script&lang=ts"
export * from "./FavoriteButton.vue?vue&type=script&lang=ts"

import "./FavoriteButton.vue?vue&type=style&index=0&id=3b690960&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__